import Vue from 'vue'
import Vuex from 'vuex'
import * as modules from './modules'
import request from '@/request'
import { DASHBOARD, HOME, UTIL } from '@/data/api'
import NProgress from 'nprogress'
import _ from 'lodash'

Vue.use(Vuex)
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false })

let autoLoadModules = {}
for (let [key, value] of Object.entries(modules)) {
  autoLoadModules[key] = value
}

const store = new Vuex.Store({
  modules: _.cloneDeep(autoLoadModules),
  state: {
    profileEditModal: false,
    dashboard: {
      fusebox: 0,
      scan: 0,
      scanCurrent: 0,
      label: 0,
      user: 0,
      location: 0
    },
    activities: [],
    latest: {
      fuseboxes: [],
      users: [],
      locations: []
    }
  },
  getters: {
    profileEditModal: state => state.profileEditModal,
    dashboard: state => state.dashboard,
    activities: state => state.activities,
    latest: state => state.latest
  },
  mutations: {
    resetState (state) {
      _.forOwn(autoLoadModules, (value, key) => {
        if (key !== 'language') {
          state[key] = _.cloneDeep(value.state)
        }
      })
      const newState = {
        profileEditModal: false,
        dashboard: {
          fusebox: 0,
          scan: 0,
          scanCurrent: 0,
          label: 0,
          user: 0,
          location: 0
        },
        activities: [],
        latest: {
          fuseboxes: [],
          users: [],
          locations: []
        }
      }
      state = { ...state, ...newState }
    },
    setProfileEditModal (state, value) {
      state.profileEditModal = value
    },
    setDashboard (state, value) {
      state.dashboard = value
    },
    setActivities (state, value) {
      state.activities = value
    },
    setLatest (state, value) {
      state.latest.fuseboxes = value.fuseboxes
      state.latest.users = value.users
      state.latest.locations = value.locations
    }
  },
  actions: {
    async appInit ({ commit, dispatch }, needLogin = true) {
      try {
        await dispatch('language/init')
        if (needLogin) {
          await dispatch('auth/init')
        }
      } catch (e) {
        //
      }
    },
    async dashboardInit ({ commit }) {
      try {
        const { data } = await request.get(DASHBOARD)
        commit('setDashboard', data.data.count)
        commit('setActivities', data.data.activity)
        commit('setLatest', data.data.latest)
      } catch (e) {
        //
      }
    },
    async geocode ({ commit }, params) {
      try {
        const { data } = await request.post(HOME.GEOCODE, params)
        return data
      } catch (e) {
        throw e
      }
    },
    async countryList ({ commit }) {
      try {
        const { data } = await request.get(UTIL.COUNTRY)
        return data
      } catch (e) {
        throw e
      }
    }
  }
})

store.watch(state => state.loader.loading, (newVal, oldVal) => {
  if (newVal === 0) return NProgress.done()
  if (oldVal === 0) return NProgress.start()
  NProgress.set(1.8 / Math.max(oldVal, newVal))
})

export default store
